import {
    CLEAR_BUSINESS,
    SET_CURRENT_BUSINESS,
    SET_BUSINESS_LIST,
    SET_BUSINESS_PRODUCTION_MODE,
    CLEAR_CURRENT_BUSINESS
} from "./types";

export const setCurrentBusinessAction = (business) => ({
    type: SET_CURRENT_BUSINESS,
    payload: business,
});

export const clearCurrentBusinessAction = () => ({
    type: CLEAR_CURRENT_BUSINESS,
});

export const setBusinessListAction = (list) => ({
    type: SET_BUSINESS_LIST,
    payload: list,
});

export const setBusinessProductionAction = (value) => ({
    type: SET_BUSINESS_PRODUCTION_MODE,
    payload: value,
});

export const clearBusinessAction = () => ({
    type: CLEAR_BUSINESS,
});
